import { parseMessage } from '@atcreate-inc/sigfox-decoder'
import { useEffect, useState } from 'react'
import { SigFoxMessageType, TMessageSigfoxOut } from '../common/enums'
import { api } from '../services'
import { SubLayout } from '../layouts/SubLayout'

interface Props {
  sigfoxId: string
}

export function TestMessageViewer({ sigfoxId }: Props) {
  const [rawMessages, setRawMessages] = useState<any[]>([])

  useEffect(() => {
    if (sigfoxId !== '') {
      const to = Math.floor(Date.now() / 1000)
      const from = to - 10 * 3600 * 24
      const order = 'desc'
      api.getRawSigfoxMessages(sigfoxId, to, from, order, 5000).then((response) => {
        const rawMessages = response.data.sort()

        setRawMessages(rawMessages)
      })
    }
  }, [sigfoxId]) // eslint-disable-line react-hooks/exhaustive-deps

  function determineMessageType(message: string) {
    const byte = message.slice(0, 2)
    const messageType = parseInt(byte, 16)
    return SigFoxMessageType[messageType]
  }

  function sortData(data: TMessageSigfoxOut[]) {
    return data.sort((a, b) => b.MSG_RAW_ID - a.MSG_RAW_ID)
  }

  return (
    <SubLayout>
      <div>
        <h3>Test Message Viewer</h3>
        <div className={tailwind.rawMessages}>
          <table>
            <thead>
              <tr>
                <th className={tailwind.tableCellFirstColumn}>Raw Message Id</th>
                <th className={tailwind.tableCell}>Device Seq.No.</th>
                {/* <th className={tailwind.tableCell}>TIME</th> */}
                <th className={tailwind.tableCell}>Date Time</th>
                <th className={tailwind.tableCell}>MSG_CONTENT</th>
                <th className={tailwind.tableCell}>Message Type</th>
                <th className={tailwind.tableCell}>Test Message</th>
              </tr>
            </thead>
            <tbody className={tailwind.tableOverflow}>
              {sortData(rawMessages)
                .filter((message) => determineMessageType(message.MSG_CONTENT) === 'TestMessage')
                .map((message: TMessageSigfoxOut, index: number) => {
                  return (
                    <tr key={index} className={index % 2 ? '' : 'bg-slate-200'}>
                      <td className={tailwind.tableCell}>{message.MSG_RAW_ID}</td>
                      <td className={tailwind.tableCellFirstColumn}>{message.SIGFOX_SNUM}</td>
                      <td className={tailwind.tableCellDateTime} style={{ minWidth: '200px' }}>
                        {new Date(message.SIGFOX_TIME * 1000).toLocaleString()}
                      </td>
                      <td className={tailwind.tableCell}>{message.MSG_CONTENT}</td>
                      <td className={tailwind.tableCell}>{determineMessageType(message.MSG_CONTENT)}</td>
                      <td className={tailwind.tableCellParsedMessage} style={{ width: '100px' }}>
                        {parseMessage(message.MSG_CONTENT).message}
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </div>
    </SubLayout>
  )
}

const tailwind = {
  // row: 'mb-3 flex flex-row justify-between',
  row: 'mb-3',
  rawMessages: 'overflow overflow-y-auto',
  tableCell: 'pr-5',
  tableCellFirstColumn: 'pl-3 pr-5',
  tableCellDateTime: 'pr-5',
  tableOverflow: 'overflow overflow-y-auto',
  tableCellParsedMessage: 'pr-5',
  alert: 'bg-red-500 text-white font-bold rounded px-4 py-2 mb-10 mt-6 h20 w-[220px] mx-auto text-center',
}
